var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8809 6.66865L6.71562 2.18564C6.67598 2.15146 6.62539 2.13232 6.57207 2.13232H5.36211C5.26094 2.13232 5.21445 2.25811 5.29102 2.32373L10.0789 6.47998H2.07812C2.01797 6.47998 1.96875 6.5292 1.96875 6.58936V7.40967C1.96875 7.46982 2.01797 7.51904 2.07812 7.51904H10.0775L5.28965 11.6753C5.21309 11.7423 5.25957 11.8667 5.36074 11.8667H6.61172C6.6377 11.8667 6.66367 11.8571 6.68281 11.8394L11.8809 7.33037C11.9282 7.28921 11.9661 7.23838 11.9921 7.1813C12.0181 7.12423 12.0316 7.06223 12.0316 6.99951C12.0316 6.93679 12.0181 6.8748 11.9921 6.81772C11.9661 6.76064 11.9282 6.70981 11.8809 6.66865Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.bc1b23c4d8213e13a34f2106ee940003.svg";
export { ForwardRef as ReactComponent };